import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import {
  Button,
  Col,
  CustomInput,
  Form,
  FormGroup,
  Input,
  Label,
  Row
} from "reactstrap";
import { toast } from "react-toastify";
import _ from "lodash";
import Select from "react-select";
import { vitalsBody } from "./configBody";
import Heading from "./Heading";
import RequiredSelect from "./RequiredSelect";
import { VitalsIcon } from "./RuleIcon";

class Vitals extends Component {
  constructor(props) {
    super(props);

    this.props.dispatch({
      type: "DO_GET_USERS_LIST"
    });

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "1",
      modal: false,
      modal2: false,
      emailOffer: "",
      emailAccess: "",
      body: vitalsBody,
      showInputCondition: false,
      showRangeInput: false,
      showAlertSuccess: false,
      minValue: '',
      maxValue: '',
      value: '',
    };
    this.baseState = this.state.body;
    this.handleChange = this.handleChange.bind(this);
    this.handleUsers = this.handleUsers.bind(this);
    this.handleCondition = this.handleCondition.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.submit = this.submit.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }
  resetForm() {
    this.setState({
      modal: false,
      modal2: false
    });

    this.props.dispatch({
      type: "GENERIC_ERROR",
      payload: { isGenericSuccess: false }
    });

    this.setState({
      body: {
        ...this.state.body,
        vitalsBody
      }
    });
    this.state.body.notifySelf.length = 0;
    this.state.body.notifyReadingOwner.length = 0;
    this.state.body.notifyStaff.length = 0;
    this.props.history.goBack();
  }
  handleChange = (selectedOption) => {
    this.setState({ readingSubType: selectedOption });
  
    this.setState({
      body: {
        ...this.state.body,
        readingType: selectedOption.reading,
        readingSubType: selectedOption.name,
        readingSubTypeId: selectedOption._id
      }
    });
  };
  submit(e) {
    e.preventDefault();

    if (
      this.state.body.notifyReadingOwner.length > 0 &&
      this.state.body.message.trim().length === 0
    ) {
      toast.error(
        "A notification is checked in notify reading owner, please provide a message for the Patient"
      );
    } else if ((this.state.body?.notifyStaff.length > 0 ||
        this.state.body.notifySelf.length > 0) && this.state.body.messageCareprovider?.trim().length === 0) {
      toast.error(
        "A notification is checked in notify me/staff, please provide a message for the care prodiver/Staff"
      );
    } else {
      this.props.dispatch({
        type: "DO_SAVE_VITAL_RULE",
        payload: this.state.body
      });
    }
  }

  handleCondition = (selectedOption) => {
    this.setState({ condition: selectedOption });
    this.setState({
      body: {
        ...this.state.body,
        condition: selectedOption.value,
        valueProperty: []
      },
      condition: selectedOption,
      showInputCondition: true
    });

    
    if (selectedOption.value == "between") {
      this.setState({
        showRangeInput: true,
        minValue: '',
        maxValue: ''
      });
    } else {
      this.setState({
        showRangeInput: false,
        value: '',
        minValue: '',
        maxValue: ''
      });
    }
  };
  handleConditions = (selectedOption) => {
    
    this.setState({
      body: {
        ...this.state.body,
        conditionGroup: _.map(selectedOption, "_id")
      }
    });
  };
  handleInputChange(event) {
    const target = event.target;
    const value = target.value;

    const name = target.name;
    const notifySelf = this.state.body.notifySelf;
    const notifyReadingOwner = this.state.body.notifyReadingOwner;
    const notifyStaff = this.state.body.notifyStaff;
    if (target.type === "checkbox") {
      let index;
      if (target.checked) {

        // add the numerical value of the checkbox to options array
        if (name === "notifySelf") {
          const checkSelf = notifySelf.includes(event.target.value);
          if(!checkSelf){
            notifySelf.push(event.target.value);
          }
        } else if (name === "notifyStaff") {
          const checkStaff = notifyStaff.includes(event.target.value);
          if(!checkStaff){
            notifyStaff.push(event.target.value);
          }
        } else {
          const checkReadingOwner = notifyReadingOwner.includes(event.target.value);
          if(!checkReadingOwner){
            notifyReadingOwner.push(event.target.value);
          }
        }
      } else {
        // or remove the value from the unchecked checkbox from the array
        if (name === "notifySelf") {
          index = notifySelf.indexOf(event.target.value);
          notifySelf.splice(index, 1);
        } else if (name === "notifyStaff") {
          index = notifyStaff.indexOf(event.target.value);
          notifyStaff.splice(index, 1);
        } else {
          index = notifyReadingOwner.indexOf(event.target.value);
          notifyReadingOwner.splice(index, 1);
        }
      }
      this.setState({
        body: {
          ...this.state.body,
          notifySelf: notifySelf,
          notifyReadingOwner: notifyReadingOwner,
          notifyStaff: notifyStaff
        }
      });
      return;
    }

    if (name == "maxValue" || name == "minValue" || name == "value") {
      this.setState({
        body: {
          ...this.state.body,
          valueProperty: { ...this.state.body.valueProperty, [name]: value }
        },
        [name] : value
      });
      return;
    }
    this.setState({ body: { ...this.state.body, [name]: value } });
  }

  handleUsers = (selectedOption) => {
    // this.setState({ sharedUsers: selectedOption });
    // const receivedFrom = _.map(selectedOption, "receivedFrom");
    // this.setState({
    //   body: {
    //     ...this.state.body,
    //     sharedUsers: _.map(receivedFrom, "_id")
    //   }
    // });

    this.setState({ sharedUsers: selectedOption });
    this.setState({
      body: {
        ...this.state.body,
        sharedUsers: _.map(selectedOption, "_id")
      }
    });

    
  };

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  componentDidMount() {
    if (!this.props.isCareProvider) {
      this.setState({
        body: {
          ...this.state.body,
          sharedUsers: [this.props.userId]
        }
      });
    }
    this.props.dispatch({
      type: "GENERIC_ERROR",
      payload: { isGenericSuccess: false }
    });
  }
  render() {
    return (
      <div>
        <div className="row">
          <Heading
            backbutton="d-flex"
            mainbutton="d-none"
            isCareProvider={this.props.isCareProvider}
            title="Create New Vitals Monitoring"
          >
            <img
              src={VitalsIcon}
              className="mr-2"
              style={{ width: "40px", height: "40px" }}
              alt="image"
            />
          </Heading>
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body project-tab pt-2 mt-4">
                <Form onSubmit={this.submit}>
                  <FormGroup>
                    <Label for="exampleEmail">Expectation Name</Label>
                    <Input
                      type="text"
                      name="name"
                      id="exampleEmail"
                      required={true}
                      className="input-date-filter"
                      onChange={this.handleInputChange}
                      placeholder="Expectation Name"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="exampleText">
                      Notification Message (Patient)
                    </Label>
                    <Input
                      type="textarea"
                      name="message"
                      className="input-date-filter"
                      onChange={this.handleInputChange}
                      rows={10}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="exampleText">
                      Notification Message (Careprovider)
                    </Label>
                    <Input
                      type="textarea"
                      name="messageCareprovider"
                      className="input-date-filter"
                      onChange={this.handleInputChange}
                      rows={10}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="exampleSelect">Pick a Reading Type</Label>
                    <RequiredSelect
                      SelectComponent={Select}
                      required={true}
                      // value={this.state.sharedUsers}
                      value={this.state.readingSubTypesForExpecation}
                      onChange={this.handleChange}
                      getOptionLabel={(option) =>
                        option["name"] + " (" + option["abbrev"] + ")"
                      }
                      getOptionValue={(option) => option["_id"]}
                      options={this.props.readingSubTypesForExpecation}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="exampleSelect">Analyze By</Label>
                    <RequiredSelect
                      SelectComponent={Select}
                      required={true}
                      // value={this.state.sharedUsers}
                      value={this.state.condition}
                      onChange={this.handleCondition}
                      options={[
                        { value: "between", label: "In Range" },
                        { value: ">=", label: "Greater Than" },
                        { value: "<=", label: "Less Than" }
                      ]}
                    />
                  </FormGroup>
                  <Row
                    form
                    className={!this.state.showInputCondition ? "d-none" : ""}
                  >
                    <Col
                      md={6}
                      className={!this.state.showRangeInput ? "d-none" : ""}
                    >
                      <FormGroup>
                        <Label for="exampleEmail">Min Value</Label>
                        <Input
                          required={this.state.showRangeInput}
                          className="input-date-filter"
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          name="minValue"
                          min={0}
                          max={this.state.maxValue}
                          value={this.state.minValue}
                          onChange={this.handleInputChange}
                          placeholder="Input Reading Min Value"
                        />
                      </FormGroup>
                    </Col>
                    <Col
                      md={6}
                      className={!this.state.showRangeInput ? "d-none" : ""}
                    >
                      <FormGroup>
                        <Label for="examplePassword">Max Value</Label>
                        <Input
                          required={this.state.showRangeInput}
                          className="input-date-filter"
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          name="maxValue"
                          value={this.state.maxValue}
                          min={this.state.minValue}
                          onChange={this.handleInputChange}
                          placeholder="Input Reading Max Value"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup
                    className={this.state.showRangeInput ? "d-none" : ""}
                  >
                    <Label for="exampleText">Value</Label>
                    <Input
                      required={!this.state.showRangeInput}
                      className="input-date-filter"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      name="value"
                      min={0}
                      value={this.state.value}
                      onChange={this.handleInputChange}
                      placeholder="Input Reading Value"
                    />
                  </FormGroup>
                  {this.props.isCareProvider && (
                    <>
                      <FormGroup>
                        <Label for="exampleSelect">
                          Select a Condition to Monitor
                        </Label>
                        <RequiredSelect
                          SelectComponent={Select}
                          // value={this.state.sharedUsers}
                          onChange={this.handleConditions}
                          options={this.props.conditions}
                          isMulti={true}
                          getOptionLabel={(option) =>
                            `${option["condition"]}  (${option["description"]})`
                          }
                          getOptionValue={(option) => option["_id"]}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="exampleSelect">
                          Select a Patient to Monitor
                        </Label>
                        <Select
                          value={this.state.sharedUsers}
                          onChange={this.handleUsers}
                          options={this.props.assignedUsersList}
                          isMulti={true}
                          getOptionLabel={(option) =>
                            option["fname"] + " " + option["lname"]
                          }
                          getOptionValue={(option) => option}
                          isLoading={this.props.assignedUsersList ? false : true}
                          isDisabled={this.props.assignedUsersList ? false : true}
                        />
                      </FormGroup>
                    </>
                  )}
                  {this.props.isCareProvider && (
                    <FormGroup>
                      <Label for="exampleCheckbox">Notify Me</Label>
                      <div>
                        <CustomInput
                          type="checkbox"
                          id="exampleCustomInline"
                          name="notifySelf"
                          onChange={this.handleInputChange}
                          value="inbox"
                          label="INBOX"
                          inline
                        />
                        <CustomInput
                          type="checkbox"
                          id="exampleCustomInline2"
                          name="notifySelf"
                          onChange={this.handleInputChange}
                          label="SMS"
                          value="sms"
                          inline
                        />
                        <CustomInput
                          type="checkbox"
                          id="exampleCustomInline3"
                          name="notifySelf"
                          onChange={this.handleInputChange}
                          label="VOICE"
                          value="voice"
                          inline
                        />
                        <CustomInput
                          type="checkbox"
                          id="exampleCustomInline4"
                          name="notifySelf"
                          onChange={this.handleInputChange}
                          label="EMAIL"
                          value="email"
                          inline
                        />
                      </div>
                    </FormGroup>
                  )}

                  <FormGroup>
                    {this.props.isCareProvider && (
                      <Label for="exampleCheckbox">Notify Readings Owner</Label>
                    )}

                    <div>
                      <CustomInput
                        type="checkbox"
                        id="exampleCustomInline6"
                        name="notifyReadingOwner"
                        onChange={this.handleInputChange}
                        value="inbox"
                        label="INBOX"
                        inline
                      />
                      <CustomInput
                        type="checkbox"
                        id="exampleCustomInline7"
                        name="notifyReadingOwner"
                        onChange={this.handleInputChange}
                        label="SMS"
                        value="sms"
                        inline
                      />
                      <CustomInput
                        type="checkbox"
                        id="exampleCustomInline8"
                        name="notifyReadingOwner"
                        onChange={this.handleInputChange}
                        label="VOICE"
                        value="voice"
                        inline
                      />
                      <CustomInput
                        type="checkbox"
                        id="exampleCustomInline9"
                        name="notifyReadingOwner"
                        onChange={this.handleInputChange}
                        label="EMAIL"
                        value="email"
                        inline
                      />
                    </div>
                  </FormGroup>

                  <FormGroup>
                    {this.props.isCareProvider && (
                      <Label for="exampleCheckbox">Notify Staff</Label>
                    )}

                    <div>
                      <CustomInput
                        type="checkbox"
                        id="exampleCustomInline10"
                        name="notifyStaff"
                        onChange={this.handleInputChange}
                        value="inbox"
                        label="INBOX"
                        inline
                      />
                      <CustomInput
                        type="checkbox"
                        id="exampleCustomInline11"
                        name="notifyStaff"
                        onChange={this.handleInputChange}
                        label="SMS"
                        value="sms"
                        inline
                      />
                      <CustomInput
                        type="checkbox"
                        id="exampleCustomInline12"
                        name="notifyStaff"
                        onChange={this.handleInputChange}
                        label="VOICE"
                        value="voice"
                        inline
                      />
                      <CustomInput
                        type="checkbox"
                        id="exampleCustomInline13"
                        name="notifyStaff"
                        onChange={this.handleInputChange}
                        label="EMAIL"
                        value="email"
                        inline
                      />
                    </div>
                  </FormGroup>

                  <Button
                    type="submit"
                    className="btn btn-info btn-lg btn-block px-10"
                  >
                    Submit
                  </Button>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <SweetAlert
          success
          title="Success!"
          show={this.props.isGenericSuccess}
          onConfirm={this.resetForm}
          confirmBtnBsStyle="info"
        >
          Submitted Successfully
        </SweetAlert>
        <SweetAlert
          error
          title={this.props.genericErrorMessage.message}
          show={this.props.isGenericError}
          onConfirm={() => {
            this.props.dispatch({
              type: "GENERIC_ERROR"
            });
          }}
          confirmBtnBsStyle="danger"
          timeout={1000}
        >
          Error Code: {this.props.genericErrorMessage.error}
        </SweetAlert>
      </div>
    );
  }
}
const mapStateToProps = ({ careprovider, user }) => {
  const {
    readingSubTypes,
    readingSubTypesForExpecation,
    assignedUsersList,
    isGenericSuccess,
    isGenericError,
    conditions,
    genericErrorMessage
  } = careprovider;
  const userId = user.userDetails._id;
  const isCareProvider = user.userDetails.isCareProvider;
  return {
    readingSubTypes,
    readingSubTypesForExpecation,
    assignedUsersList,
    userId,
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    conditions,
    isCareProvider
  };
};

export default connect(mapStateToProps)(Vitals);
